export default class FormsListContext{
    constructor(mode = "default", excludedIds = [], activityType, formValidatedFieldWithParent) {
        this.mode = mode; // or select
        this.excludedIds = excludedIds;
        this.activityType = activityType;
        this.formValidatedFieldWithParent = formValidatedFieldWithParent;

        // tree
        this.excludedTreeBranch = null;
        this.treeConfig = null;
        this.allowNoSelection = null;
        this.multielect = false;
        this.multiSelectAutoOn = false;
    }
}